import Home from '@/app/views/home.vue'
import Register from '@/users/views/register.vue'
import Login from '@/users/views/login.vue'
import ResetPassword from '@/users/views/reset-password.vue'

import Projects from '@/projects/views/projects'
import Stakeholders from '@/stakeholders/views/stakeholders'

import Spider from '@/diagrams/components/spider/Spider.vue'
import MSpider from '@/diagrams/components/message/MSpider.vue'
import Bubble from '@/diagrams/components/bubble/Bubble.vue'
import Action from '@/diagrams/components/matrix/Matrix.vue'
import Timeline from '@/diagrams/components/timeline/Timeline.vue'

import Settings from '@/users/views/settings.vue'
import Tenants from '@/tenants/views/tenants.vue'
import Users from '@/users/views/users.vue'

import Error from '@/app/views/error.vue'
import ProjectDetail from '@/projects/views/detail'

import Demo from '@/common/views/demo.vue'

import Test from '@/emergo/views/test.vue'

import ActionGroups from '../actions/views/action-groups.vue'

export default {
  // Default route the user will be redirected to if none is specified in the
  // request params.
  loginDefaultRedirect: {
    ADMIN: '/users',
    TENANT: '/projects',
    DEFAULT: '/projects',
  },

  // Route to redirect to after a successful logout.
  logoutRedirect: '/login',

  routes: [
    {
      path: '/',
      name: 'home',
      component: Projects,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'sidebar-layout',
        showHeader: false,
        showSideMenu: false,
      },
    },
    {
      path: '/login/:redirectUrl?',
      name: 'login',
      component: Login,
      meta: {
        layout: 'empty-layout',
      },
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
      props: true,
      meta: {
        layout: 'empty-layout',
      },
    },

    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/emergo-test',
      name: 'emergo',
      component: Test,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/projectdetail/:projectId',
      name: 'projectDetail',
      component: ProjectDetail,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/stakeholders',
      name: 'stakeholders',
      component: Stakeholders,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/action-groups',
      name: 'action-groups',
      component: ActionGroups,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },

    {
      path: '/spider/:projectId/:type',
      name: 'spider',
      component: Spider,
      props: true,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/mspider/:projectId/:type',
      name: 'mspider',
      component: MSpider,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/bubble',
      name: 'bubble',
      component: Bubble,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/action',
      name: 'action',
      component: Action,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        fullscreen: false,
      },
    },

    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        roles: ['TENANT'],
      },
    },

    {
      path: '/tenants',
      name: 'tenants',
      component: Tenants,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        layout: 'sidebar-layout',
        showSideMenu: true,
        requiresAuth: true,
        roles: ['ADMIN'],
      },
    },

    {
      path: '/demo',
      name: 'demo',
      component: Demo,
      meta: {
        layout: 'sidebar-layout',
        // showSideMenu: true,
        // requiresAuth: true,
        // roles: ['ADMIN'],
      },
    },

    // Error page.
    {
      path: '/error/:status',
      name: 'error',
      component: Error,
      meta: {
        layout: 'empty-layout',
        showSideMenu: false,
        fullscreen: false,
      },
    },

    // Fallback redirect.
    { path: '*', redirect: '/error/404' },
  ],
}
